<template>
  <div class="mit-landing-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>CSAIL Keys Application</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p><a href="/auth/provider">Please sign in.</a></p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../main.js';

  export default {
    name: 'MitMyKeysPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
